module.exports = __webpack_public_path__ + "static/media/3.61882c0f.jpg";